// extracted by mini-css-extract-plugin
module.exports = {"skills":"Skills_skills__1ib7X","skills_js":"Skills_skills_js__2YN_r","skills_python":"Skills_skills_python__3Su-e","skills_image":"Skills_skills_image__1AL7n"};